import { NoticeTypes } from '@genial/components';
import { Utils } from '@genial/utils';
import { Dimensions } from 'react-native';

import { messageError } from '../../../NewApplication/Product/components/Equity/constants';
import { OrderEntityWithEvents } from '../OrderDetails/constants';

export const noticeTitle: NoticeTypes.TextObject[] = [
  {
    text: 'Caso sua ordem esteja parcialmente executada, só será cancelada parte da negociação ainda em aberto.',
    variant: 'regular',
  },
];

export const { height } = Dimensions.get('window');

export const orderEquityInfoGetter = (data?: OrderEntityWithEvents) => {
  const accountNumber = data?.account?.accountNumber;
  const accountDigit = data?.account?.accountDigit;

  return [
    { label: 'Cliente', value: data?.customer?.customerName || messageError },
    {
      label: 'Conta',
      value:
        accountNumber && (accountDigit || accountDigit === 0)
          ? `${accountNumber}-${accountDigit}`
          : messageError,
    },
    { label: 'Produto', value: data?.marketType || messageError },
    { label: 'Ativo', value: data?.offer?.productDisplay || messageError },
    { label: 'Operação', value: data?.sideDescription || messageError },
    { label: 'Tipo da ordem', value: data?.orderType || messageError },
    { label: 'Qtd. solicitada', value: data?.requestedQuantity?.toString() || messageError },
    {
      label: 'Preço médio exe.',
      value: Utils.Mask.Money(data?.executedAveragePrice || 0),
    },
  ];
};
